import { surveyLocalization } from "../surveyStrings";

export var hebrewSurveyStrings = {
  pagePrevText: "אחורה",
  pageNextText: "קדימה",
  completeText: "סיום",
  previewText: "תצוגה מקדימה",
  editText: "לַעֲרוֹך",
  startSurveyText: "הַתחָלָה",
  otherItemText: "אחר (נא לתאר)",
  noneItemText: "אף אחד",
  selectAllItemText: "בחר הכל",
  progressText: "דף {1} מתוך {0}",
  panelDynamicProgressText: "הקלטה {0} מתוך {1}",
  questionsProgressText: "ענה על שאלות",
  emptySurvey: "אין שאלות",
  completingSurvey: "תודה על מילוי השאלון!",
  completingSurveyBefore:
    "הרשומות שלנו מראות שכבר סיימת את הסקר הזה.",
  loadingSurvey: "טעינה מהשרת...",
  optionsCaption: "בחר...",
  value: "ערך",
  requiredError: "אנא השב על השאלה",
  requiredErrorInPanel: "אנא ענה לפחות על שאלה אחת.",
  requiredInAllRowsError: "אנא ענה על שאלות בכל השורות.",
  numericError: "התשובה צריכה להיות מספר.",
  textMinLength: "הזן לפחות {0} תווים.",
  textMaxLength: "הזן פחות מ- {0} תווים.",
  textMinMaxLength: "הזן יותר מ- {0} ופחות מ- {1} תווים.",
  minRowCountError: "אנא מלא לפחות {0} שורות.",
  minSelectError: "בחר לפחות {0} אפשרויות.",
  maxSelectError: "בחר עד {0} אפשרויות.",
  numericMinMax:
    "'{0}' חייב להיות שווה או גדול מ {1}, ושווה ל- {2} או פחות מ- {}}",
  numericMin: "'{0}' חייב להיות שווה או גדול מ {1}",
  numericMax: "'{0}' חייב להיות שווה או קטן מ {1}",
  invalidEmail: 'הזן כתובת דוא"ל חוקית.',
  invalidExpression: "הביטוי: {0} צריך להחזיר 'אמת'.",
  urlRequestError: "הבקשה החזירה את השגיאה '{0}'. {1}",
  urlGetChoicesError:
    "הבקשה החזירה נתונים ריקים או שהמאפיין 'נתיב' שגוי",
  exceedMaxSize: "גודל הקובץ לא יעלה על {0}.",
  otherRequiredError: 'נא להזין נתונים בשדה "אחר"',
  uploadingFile:
    "הקובץ שלך נטען. המתן מספר שניות ונסה שוב.",
  loadingFile: "טוען...",
  chooseFile: "לבחור קבצים...",
  noFileChosen: "לא נבחר קובץ",
  confirmDelete: "האם אתה רוצה למחוק את הרשומה?",
  keyDuplicationError: "ערך זה צריך להיות ייחודי.",
  addColumn: "הוסף עמודה",
  addRow: "להוסיף שורה",
  removeRow: "לְהַסִיר",
  addPanel: "הוסף חדש",
  removePanel: "לְהַסִיר",
  choices_Item: "פריט",
  matrix_column: "טור",
  matrix_row: "שׁוּרָה",
  savingData: "התוצאות נשמרות בשרת ...",
  savingDataError: "אירעה שגיאה ולא הצלחנו לשמור את התוצאות.",
  savingDataSuccess: "התוצאות נשמרו בהצלחה!",
  saveAgainButton: "נסה שוב",
  timerMin: "דקה",
  timerSec: "שניות",
  timerSpentAll: "הוצאת {0} בדף זה ובסך הכל {1}.",
  timerSpentPage: "הוצאת {0} בדף זה.",
  timerSpentSurvey: "הוצאת סכום כולל של {0}.",
  timerLimitAll:
    "הוצאת {0} מתוך {1} בדף זה ו- {2} מתוך {3} בסך הכל.",
  timerLimitPage: "הוצאת {0} מתוך {1} בדף זה.",
  timerLimitSurvey: "הוצאת סכום כולל של {0} מתוך {1}.",
  cleanCaption: "לְנַקוֹת",
  clearCaption: "ברור",
  chooseFileCaption: "בחר קובץ",
  removeFileCaption: "הסר קובץ זה",
  booleanCheckedLabel: "כן",
  booleanUncheckedLabel: "לא",
  confirmRemoveFile: "האם אתה בטוח שברצונך להסיר קובץ זה: {0}?",
  confirmRemoveAllFiles: "האם אתה בטוח שברצונך להסיר את כל הקבצים?",
  questionTitlePatternText: "כותרת שאלה",
};

surveyLocalization.locales["he"] = hebrewSurveyStrings;
surveyLocalization.localeNames["he"] = "עברית";



// WEBPACK FOOTER //
// ./src/localization/hebrew.ts